import {Trans, useTranslation} from 'react-i18next';
import {Text} from '@treatwell/ui';
import {LegalLinkModal} from '../LegalLinkModal';
import styles from './TermsAndConditions.module.css';

export const TermsAndConditions = () => {
  const {t} = useTranslation();

  return (
    <Trans i18nKey="register.termsAndConditions.acceptText">
      <Text type="caption" className={styles.text}>
        By signing up I accept the{' '}
        <LegalLinkModal
          pageType="TERMS_OF_USE"
          label={t('register.termsAndConditions.linkLabel')}
          data-cy="TermsAndConditions"
        />
        .
      </Text>
    </Trans>
  );
};
